module.exports = __webpack_public_path__ + "static/media/washingMachineIcon.bc3809f3.svg";